module.exports = __webpack_public_path__ + "img/facebook.8354e264.svg";